import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Element
import "element-ui/lib/theme-chalk/index.css";
import "@/plugins/element";

// Bootstrap
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/plugins/bootstrap";

// Cookies
import VueCookies from "vue-cookies";
Vue.use(VueCookies);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  beforeCreate() {
    this.$store.commit("initializeStore");
  },
  render: h => h(App)
}).$mount("#app");
